import { configureStore } from '@reduxjs/toolkit';
import {
	useDispatch as dispatch,
	useSelector as selector,
	useStore as storeHook
} from 'react-redux';
import { adminReducer, genericReducer } from "./slices";

export const store = configureStore({
	reducer: {
		generic: genericReducer,
		admin: adminReducer,
	},
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const useDispatch = dispatch.withTypes<AppDispatch>();
export const useSelector = selector.withTypes<RootState>();
export const useStore = storeHook.withTypes<AppStore>();

export * from "./slices";
